/* eslint no-use-before-define: 0 */  // --> OFF
<template>
  <rfq>
    <div class="request-container tw-pt-6 tw-pb-8 tw-flex tw-justify-center ">
      <div class="tw-w-full md:tw-w-2/3 lg:tw-w-3/4">

        <div class="tw-flex tw-justify-between tw-items-center tw-mb-4">
          <BreadCrumb :breadcrumbs="updatedBreadcrumbs" />

          <div
            class="tw-flex tw-items-center tw-cursor-pointer"
            @click="goBack"
          >
            <back-nav />
          </div>
        </div>

       <!-- STEP 2:  -->
<v-card  class="main-card tw-px-8 tw-py-8 tw-bg-white tw-shadow-md">

<div class="tw-flex tw-items-start">
  <h2 class="tw-ml-4">
    <card-title >{{ titleText }}</card-title>
  </h2>
</div>
<hr class="tw-border-gray-300 tw-my-4">
<br>
<br>

<div v-if="subStep === 'PolicyType'" class=" policy-type-section tw-flex tw-items-center tw-justify-between tw-text-blue-700 tw-mb-4">
  <div class="tw-flex tw-items-center">
    <card-title icon="mdi-car">{{ (policyDetails && policyDetails.name) || 'Comprehensive' }}</card-title>
  </div>
  <span style="color: #114cac;" class="tw-font-bold tw-text-lg">
    {{ vehicleMake || '' }} {{ vehiclemodel || '' }}, {{ vehicleRegNumber || '' }}
  </span>
</div>

<div class="tw-flex tw-items-center tw-mb-8">
  <div class="tw-flex tw-justify-between tw-w-full tw-px-10">
    <div v-for="(step, index) in steps" :key="index" class="tw-flex tw-items-center tw-w-full">
      <div
        class="tw-flex tw-flex-col tw-items-center"
      >
        <div
          :class="[
            'tw-w-8 tw-h-8 lg:tw-w-8 lg:h-10 tw-flex tw-items-center tw-justify-center tw-rounded-full',
            stepClass(index)
          ]"
        >
          <v-icon v-if="index < currentStepIndex" color="white">mdi-check</v-icon>
          <span v-else>{{ index + 1 }}</span>
        </div>
      <!-- Step Label -->
        <div
          :style="index === currentStepIndex ? { color: '#114cac' } : { color: '#6b7280' }"
          class="tw-mt-1 tw-text-xs lg:tw-text-sm tw-text-center tw-font-semibold"
          :class="stepLabelClass(index)"
        >
          <span class="md:tw-hidden">{{ step.shortLabel || step.label }}</span>
          <span class="tw-hidden md:tw-inline-block lg:tw-hidden">{{ step.shortLabel }}</span>
          <span class="tw-hidden lg:tw-inline-block">{{ step.label }}</span>
        </div>

      </div>

      <v-divider
        v-if="index < steps.length - 1"
        class="tw-h-1 tw-bg-gray-300 tw-hidden md:tw-flex"
        style="width: calc(100% / 5 - 40px);"
        :class="{ 'tw-bg-blue-600': index < currentStepIndex }"
      ></v-divider>
    </div>
  </div>
</div>

<!-- Content Section for Non-Policy Steps -->
<div class="form-section tw-mt-1">
  <VehicleData v-if="currentStep === 'VehicleData'" :currentStep="currentStep" @next="goToNextStep" />
  <Declarations v-if="currentStep === 'Declarations'" :currentStep="currentStep" @next="goToNextStep" />
  <Policy v-if="subStep === 'PolicyType'" :currentStep="currentStep" :subStep="subStep" @next="handlePolicyNext" />
  <ValuerSelection v-if="subStep === 'ValuerSelection'" :currentStep="currentStep" :subStep="subStep" @next="showBranchSelection" />
  <BranchSelection v-if="subStep === 'BranchSelection'" :currentStep="currentStep" :subStep="subStep" @next="showVerifyDetails" />
  <VerifyDetails v-if="subStep === 'VerifyDetails'" :currentStep="currentStep" :subStep="subStep" @next="goToNextStep" />
  <MakePayment v-if="currentStep === 'MakePayment'" :currentStep="currentStep" />
</div>
</v-card>

      </div>
    </div>
  </rfq>
</template>

<script>
import BreadCrumb from '@/components/dashboard/BreadCrumb';
import VehicleData from '@/components/tpo/VehicleData';
import Declarations from '@/components/tpo/Declaration';
import Policy from '@/components/tpo/PolicyType';
import ValuerSelection from '@/components/tpo/ValuerSelection';
import BranchSelection from '@/components/tpo/BranchSelection';
import VerifyDetails from '@/components/tpo/VerifyDetails';
import MakePayment from '@/components/tpo/Payment';
import Rfq from '@/components/layout/Rfq';
import CardTitle from '@/components/shared/CardTitle';
import helperMixins from '@/mixins/helperMixins';
import BackNav from '@/components/buy/BackNav';
import { mapGetters } from 'vuex';

// Storage key for persisting journey progress
const RFQ_PROGRESS_KEY = 'rfq_journey_progress';

export default {
  name: 'RequestTPO',
  components: {
    BreadCrumb,
    VehicleData,
    Declarations,
    Policy,
    ValuerSelection,
    BranchSelection,
    VerifyDetails,
    MakePayment,
    Rfq,
    CardTitle,
    BackNav,
  },
  mixins: [helperMixins],
  data() {
    return {
      currentStep: 'VehicleData',
      subStep: 'null',
      steps: [
        { step: 'VehicleData', label: 'Vehicle Details', shortLabel: 'Vehicle' },
        { step: 'Declarations', label: 'Declarations', shortLabel: 'Declarations' },
        { step: 'Policy', label: 'Policy Type & Branch', shortLabel: 'Policy' },
        { step: 'MakePayment', label: 'Make Payment', shortLabel: 'Payments' },
      ],
    };
  },
  computed: {

    ...mapGetters(['policyDetails']),
    updatedBreadcrumbs() {
      return [
        { text: 'Get Started', disabled: false, to: { name: 'GetStarted' } },
        { text: this.getCurrentStepLabel(), disabled: true, to: '' },
      ];
    },
    titleText() {
      if (this.currentStep === 'Policy' && this.subStep === 'VerifyDetails') {
        return 'Verify Details';
      }

      if (this.currentStep === 'Policy' && ['PolicyType', 'BranchSelection'].includes(this.subStep)) {
        return 'Policy Details Overview';
      }

      if (this.currentStep === 'MakePayment') {
        return 'Policy Details Overview';
      }

      return 'Get Started with us';
    },
    currentStepIndex() {
      return this.steps.findIndex((step) => step.step === this.currentStep);
    },
    stepClass() {
      return (index) => {
        if (index < this.currentStepIndex) {
          return 'tw-bg-blue-600 tw-text-white';
        }

        if (index === this.currentStepIndex) {
          return 'tw-bg-yellow-500 tw-text-white';
        }

        return 'tw-bg-gray-300 tw-text-gray-600';
      };
    },

    stepLabelClass() {
      return (index) => (index === this.currentStepIndex ? 'tw-text-blue-600 tw-font-semibold' : 'tw-text-gray-500');
    },
  },
  mounted() {
    this.fetchVehicleDetails();
    this.restoreProgress();
  },

  methods: {
    saveProgress(step, subStep = null) {
      const progress = {
        currentStep: step,
        subStep,
      };
      localStorage.setItem(RFQ_PROGRESS_KEY, JSON.stringify(progress));
    },

    restoreProgress() {
      const status = this.$route.query.status;
      if (status === 'success' || status === 'cancelled') {
        this.currentStep = 'MakePayment';
        this.subStep = null;
        return;
      }

      const savedProgressStr = localStorage.getItem(RFQ_PROGRESS_KEY);
      if (!savedProgressStr) return;

      const savedProgress = JSON.parse(savedProgressStr);

      const hasVehicle = !!localStorage.getItem('vehicleDetails');
      const hasCustomer = !!localStorage.getItem('formPayload');
      const hasQuote = !!localStorage.getItem('quoteId');

      let targetStep = savedProgress.currentStep;
      let targetSubStep = savedProgress.subStep;

      if (targetStep === 'MakePayment' && !hasQuote) {
        targetStep = 'Policy';
        targetSubStep = 'VerifyDetails';
      }
      if (targetStep === 'Policy' && !hasCustomer) {
        targetStep = 'Declarations';
        targetSubStep = null;
      }
      if (targetStep === 'Declarations' && !hasVehicle) {
        targetStep = 'VehicleData';
        targetSubStep = null;
      }

      this.currentStep = targetStep;
      this.subStep = targetSubStep;

      if (hasVehicle) {
        this.fetchVehicleDetails();
      }
    },

    goBack() {
      if (this.currentStep === 'Policy') {
        switch (this.subStep) {
          case 'VerifyDetails':
            this.subStep = 'BranchSelection';
            break;
          case 'BranchSelection':
            // eslint-disable-next-line sonarjs/no-duplicate-string
            if (this.policyDetails?.name === 'Bima Bamba' || this.policyDetails?.name === 'Comprehensive') {
              this.subStep = 'ValuerSelection';
            } else {
              this.subStep = 'PolicyType';
            }
            break;
          case 'ValuerSelection':
            this.subStep = 'PolicyType';
            break;
          case 'PolicyType':
            this.currentStep = 'Declarations';
            this.subStep = null;
            break;
          default:
            this.$toast.error(`Unhandled subStep: ${this.subStep}`);
        }
      } else {
        switch (this.currentStep) {
          case 'VehicleData':
            this.currentStep = 'VehicleData';
            break;
          case 'Declarations':
            this.currentStep = 'VehicleData';
            break;
          case 'Policy':
            this.currentStep = 'Declarations';
            break;
          case 'ValuerSelection':
            this.currentStep = 'Policy';
            this.subStep = 'PolicyType';
            break;
          case 'MakePayment':
            if (this.policyDetails?.name === 'Bima Bamba' || this.policyDetails?.name === 'Comprehensive') {
              this.currentStep = 'Policy';
              this.subStep = 'VerifyDetails';
            } else {
              this.currentStep = 'Policy';
              this.subStep = 'BranchSelection';
            }
            break;
          default:
            this.$toast.warn(`Unhandled currentStep: ${this.currentStep}`);
        }
      }
      this.saveProgress(this.currentStep, this.subStep);
    },
    fetchVehicleDetails() {
      const retrievedPayload = JSON.parse(localStorage.getItem('vehicleDetails'));
      if (retrievedPayload && retrievedPayload.vehicle) {
        this.vehicleMake = retrievedPayload.vehicle.make || '';
        this.vehicleRegNumber = retrievedPayload.vehicle.regNo || '';
        this.vehiclemodel = retrievedPayload.vehicle.model || '';
      } else {
      // Fallback or default values if data isn't available
        this.vehicleMake = '';
        this.vehicleRegNumber = '';
        this.vehiclemodel = '';
      }
    },
    goToStep(step) {
      this.fetchVehicleDetails();
      this.currentStep = step;
      this.subStep = step === 'Policy' ? 'PolicyType' : null;
    },
    getCurrentStepLabel() {
      const currentStepObj = this.steps.find((step) => step.step === this.currentStep);
      return currentStepObj ? currentStepObj.label : 'Personal Details';
    },
    goToNextStep() {
      if (this.currentStep === 'VehicleData') {
        this.currentStep = 'Declarations';
        this.saveProgress('Declarations');
      } else if (this.currentStep === 'Declarations') {
        this.currentStep = 'Policy';
        this.subStep = 'PolicyType';
        this.saveProgress('Policy', 'PolicyType');
      } else if (this.currentStep === 'Policy') {
        if (this.subStep === 'PolicyType') {
          // Delegate the decision to handlePolicyNext
          this.handlePolicyNext();
        } else if (this.subStep === 'ValuerSelection') {
          this.subStep = 'BranchSelection';
          this.saveProgress('Policy', 'BranchSelection');
        } else if (this.subStep === 'BranchSelection') {
          this.subStep = 'VerifyDetails';
          this.saveProgress('Policy', 'VerifyDetails');
        } else if (this.subStep === 'VerifyDetails') {
          this.subStep = null;
          this.currentStep = 'MakePayment';
          this.saveProgress('MakePayment');
        }
      }
    },
    handlePolicyNext() {
      if (this.policyDetails?.name === 'Bima Bamba' || this.policyDetails?.name === 'Comprehensive') {
        this.showValuerSelection();
      } else if (this.policyDetails?.name === 'Third Party') {
        this.showBranchSelection();
      }
    },

    showBranchSelection() {
      this.subStep = 'BranchSelection';
      this.saveProgress('Policy', 'BranchSelection');
    },
    showValuerSelection() {
      this.subStep = 'ValuerSelection';
      this.saveProgress('Policy', 'ValuerSelection');
    },
    showVerifyDetails() {
      this.subStep = 'VerifyDetails';
      this.saveProgress('Policy', 'VerifyDetails');
    },
  },
  watch: {
    currentStep() {
      this.fetchVehicleDetails();
      this.$forceUpdate();
    },
    subStep() {
      this.fetchVehicleDetails();
    },
  },
};
</script>

<style scoped>
.request-container {
  margin-bottom: 10%;
}
.main-card {
  border-radius: 8px;
}
.top-header {
  position: sticky;
  top: 0;
  z-index: 10;
}
</style>
